<template>

<div v-if="loading" class="loading" :class="{'theme01-root-loading':skinTheme==1,'theme02-root-loading':skinTheme==2}" id="loading-root-ele">
    <div id="loading-root-main" class="la-line-scale">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>

</template>

<script>
import {
    mapGetters
  } from 'vuex' 
  
export default {
    props: {
        loading: false,
    },
    computed: {
        ...mapGetters([
            'skinTheme',
        ]),
    },
    data() {
        return {}
    },
    mounted() {}
}
</script>



// WEBPACK FOOTER //
// resources/score/vue/components/loadingScreen.vue